import React from 'react';
import { Link } from 'react-router-dom';
import NavBar from '../../components/NavBar/NavBar';
import Footer from '../../components/Footer/Footer';
import './About.css';
import InfoBar from '../../components/InfoBar/InfoBar';

export default function About() {
  return (
    <>
    <InfoBar/>
    <NavBar />
    <div className="about-page">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="about-hero-content">
          <h1 className="about-hero-title">About Tulipink</h1>
          <p className="about-hero-subtitle">
            Crafting beautiful moments with premium flowers since 1998
          </p>
          <div className="about-hero-stats">
            <div className="stat-item">
              <span className="stat-number">25+</span>
              <span className="stat-label">Years of Excellence</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">50K+</span>
              <span className="stat-label">Happy Customers</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">100%</span>
              <span className="stat-label">Fresh Guarantee</span>
            </div>
          </div>
        </div>
        <div className="about-hero-image">
          <div className="hero-flower-decoration">
            <div className="flower-petal"></div>
            <div className="flower-petal"></div>
            <div className="flower-petal"></div>
          </div>
        </div>
      </section>

      {/* Our Story Section */}
      <section className="our-story">
        <div className="container">
          <div className="story-content">
            <div className="story-text">
              <h2 className="about-section-title">Our Story</h2>
              <p className="story-description">
                Founded in 1998, Tulipink began as a small family business with a simple mission: 
                to bring joy and beauty into people's lives through the art of floristry. What started 
                as a passion for flowers has grown into a trusted name in premium floral arrangements.
              </p>
              <p className="story-description">
                Today, we continue to honor our founding principles while embracing innovation, 
                ensuring every bouquet tells a story and every delivery creates a moment of happiness.
              </p>
              <div className="story-highlights">
                <div className="highlight-item">
                  <div className="highlight-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                    </svg>
                  </div>
                  <div className="highlight-text">
                    <h4>Premium Quality</h4>
                    <p>Only the finest flowers from trusted growers</p>
                  </div>
                </div>
                <div className="highlight-item">
                  <div className="highlight-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M1 3h15v13H1z"/>
                      <path d="M16 8h4l3 3v5h-7V8z"/>
                      <circle cx="5.5" cy="18.5" r="2.5"/>
                      <circle cx="18.5" cy="18.5" r="2.5"/>
                    </svg>
                  </div>
                  <div className="highlight-text">
                    <h4>Reliable Delivery</h4>
                    <p>Same-day delivery across the city</p>
                  </div>
                </div>
                <div className="highlight-item">
                  <div className="highlight-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
                    </svg>
                  </div>
                  <div className="highlight-text">
                    <h4>Customer Care</h4>
                    <p>Dedicated support for every order</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="story-image">
              <div className="story-image-placeholder">
                <img 
                  src="https://images.unsplash.com/photo-1490750967868-88aa4486c946?w=800&h=600&fit=crop" 
                  alt="Beautiful flower arrangement" 
                  className="story-flower-image"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Values Section */}
      <section className="our-values">
        <div className="container">
          <h2 className="about-section-title about-title-center">Our Values</h2>
          <div className="values-grid">
            <div className="value-card">
            <div className="value-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                </svg>
              </div>
              <h3 className="value-title">Quality First</h3>
              <p className="value-description">
                We source only the freshest, highest-quality flowers and maintain strict 
                quality standards in every arrangement we create.
              </p>
            </div>
            <div className="value-card">
              <div className="value-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                  <circle cx="9" cy="7" r="4"/>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                </svg>
              </div>
              <h3 className="value-title">Customer Focus</h3>
              <p className="value-description">
                Every customer interaction is an opportunity to create joy. We listen, 
                understand, and deliver beyond expectations.
              </p>
            </div>
            {/* <div className="value-card">
              <div className="value-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                </svg>
              </div>
              <h3 className="value-title">Excellence</h3>
              <p className="value-description">
                We strive for excellence in every detail, from flower selection to 
                final delivery, ensuring every experience is memorable.
              </p>
            </div> */}
            <div className="value-card">
              <div className="value-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M12 2C8.5 2 6 4.5 6 8c0 2.5 1.5 4.5 3 6l3 3 3-3c1.5-1.5 3-3.5 3-6 0-3.5-2.5-6-6-6z"/>
                </svg>
              </div>
              <h3 className="value-title">Sustainability</h3>
              <p className="value-description">
                We're committed to sustainable practices, working with eco-friendly 
                suppliers and minimizing our environmental impact.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="our-team">
        <div className="container">
          <h2 className="about-section-title about-title-center">Meet Our Team</h2>
          <div className="team-grid">
            <div className="team-member">
              <div className="member-avatar">
                <img 
                  src="https://randomuser.me/api/portraits/women/44.jpg" 
                  alt="Sarah Johnson" 
                  className="avatar-image"
                />
              </div>
              <h3 className="member-name">Sarah Johnson</h3>
              <p className="member-role">Founder & Creative Director</p>
              <p className="member-bio">
                With 25 years in floristry, Sarah brings passion and expertise to every arrangement.
              </p>
            </div>
            <div className="team-member">
              <div className="member-avatar">
                <img 
                  src="https://randomuser.me/api/portraits/men/32.jpg" 
                  alt="Michael Chen" 
                  className="avatar-image"
                />
              </div>
              <h3 className="member-name">Michael Chen</h3>
              <p className="member-role">Head Florist</p>
              <p className="member-bio">
                Michael's artistic vision and attention to detail create stunning floral masterpieces.
              </p>
            </div>
            <div className="team-member">
              <div className="member-avatar">
                <img 
                  src="https://randomuser.me/api/portraits/women/68.jpg" 
                  alt="Emma Rodriguez" 
                  className="avatar-image"
                />
              </div>
              <h3 className="member-name">Emma Rodriguez</h3>
              <p className="member-role">Customer Experience Manager</p>
              <p className="member-bio">
                Emma ensures every customer interaction is exceptional and memorable.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="about-cta">
        <div className="container">
          <div className="cta-content">
            <h2 className="cta-title">Ready to Experience the Tulipink Difference?</h2>
            <p className="cta-description">
              Discover our beautiful collection of premium flowers and arrangements, 
              crafted with love and delivered with care.
            </p>
            <div className="cta-buttons">
              <Link to="/" className="cta-button primary">
                Explore Our Collection
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M5 12h14"/>
                  <path d="M12 5l7 7-7 7"/>
                </svg>
              </Link>
              <Link to="/customer-service" className="cta-button secondary">
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
    <Footer/>
    </>
  );
}